<!-- <div class="toggle-button-container" [ngClass]="{'on-state': value, 'light-variant': type == 'light', 'disabled': formControl && formControl.disabled}" (click)="toggle()">
  <div class="base" ></div>
  <div class="toggler"></div>
</div> -->

<mis-switch (valueChanged)="toggle($event)"  [checked]="value" [ngClass]="{'disableDropdown':isDisabled }"></mis-switch>